import { ZCodeDto } from '@act/shared/data-transfer-objects';
import { PaginatedTableProps } from '@act/storybook';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hooks';
import { NeedsZcodesTableColumns } from './NeedsZcodesColumns';
import { AdminToolSkeleton } from '../../AdminToolSkeleton';
import { IndexChildContainer } from 'react-components/member-index/indexContainer';
import { PaginatedTable } from '@act/storybook';
import { useMemo, useState } from 'react';
import { NeedZcodeCreateEdit } from './NeedZcodeCreateEdit';

export const NeedZcodes = () => {
  const [zcodeCreate, setZcodeCreate] = useState(false);
  const [zcodeEdit, setZcodeEdit] = useState(false);
  const [selectedZcode, setSelectedZcode] = useState<ZCodeDto | null>(null);
  const needs = metaSliceSelectors.useSelectNeedsMetadata()?.data;

  const columns = useMemo(() => {
    return NeedsZcodesTableColumns();
  }, [needs?.zcodes]);

  const NEEDS_ZCODES_ADMIN_TABLE_PROPS: PaginatedTableProps<ZCodeDto> = {
    data: needs?.zcodes,
    columnConfig: columns,
    inMemoryPagination: true,
    onRowClick: (row: ZCodeDto) => {
      setSelectedZcode(row);
      setZcodeEdit(true);
    },
  };
  const setFormOpen = (value: boolean) => {
    if (!value) {
      setZcodeEdit(false);
      setSelectedZcode(null);
    }
  };

  return (
    <>
      <AdminToolSkeleton
        title="Needs Zcodes"
        toolDescription="Needs zcodes can be viewed and updated here."
        buttonContent="Add New Needs Zcode"
        variant="contained"
        onClick={() => setZcodeCreate(true)}
      >
        <IndexChildContainer>
          <PaginatedTable {...NEEDS_ZCODES_ADMIN_TABLE_PROPS} />
        </IndexChildContainer>
      </AdminToolSkeleton>
      {(zcodeCreate || zcodeEdit) && (
        <NeedZcodeCreateEdit
          open={zcodeCreate || zcodeEdit}
          setOpen={zcodeCreate ? setZcodeCreate : setFormOpen}
          isEdit={zcodeEdit}
          selectedZcode={selectedZcode}
        />
      )}
    </>
  );
};
